import { IsNumber, IsOptional, IsString } from 'class-validator';
import { MobileBankPaymentActionTypeEnum, WebPaymentTypeEnum } from '@up/data';

export class FireOpenForwardWebsocketMessageRequestDto {
  @IsString()
  action: MobileBankPaymentActionTypeEnum;

  @IsString()
  websocketEventName: string;

  @IsString()
  @IsOptional()
  orderId?: string;

  @IsString()
  @IsOptional()
  orderPaymentId?: string;

  @IsString()
  @IsOptional()
  paymentId?: string;

  @IsOptional()
  webPaymentType?: WebPaymentTypeEnum;

  @IsNumber()
  @IsOptional()
  referenceId?: number;

  @IsString()
  @IsOptional()
  paymentBankCode?: string;

  @IsOptional()
  @IsString()
  aspspUuid?: string;

  @IsOptional()
  @IsString()
  paymentUuid?: string;
}
